<div class="bg-marketing">
<nav class="navbar d-flex flex-wrap container-fluid align-items-center flex-row  px-4 px-md-5 gap-10-64md header-width">
  <div class="flex-column me-auto order-1">
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none">
      <path
        d="M42 5.98938C42 2.35813 39.6463 0.000488281 36.0092 0.000488281H5.99083C2.35861 0.000488281 0 2.35327 0 5.98938V36.0106C0 39.6419 2.35375 41.9995 5.99083 41.9995H36.0082C39.6404 41.9995 41.999 39.6467 41.999 36.0106V5.98938H42ZM35.7301 39.3356H6.26986C3.89278 39.3356 2.66583 38.1116 2.66583 35.7326V6.2684C2.66583 3.89229 3.88986 2.66535 6.26986 2.66535H35.7301C38.1072 2.66535 39.3342 3.88938 39.3342 6.2684V35.7326C39.3342 38.1087 38.1101 39.3356 35.7301 39.3356ZM34.2183 14.3097V25.4397H31.1578V14.7578C31.1578 14.017 30.6707 13.5387 29.9503 13.5387H28.2197V25.4397H25.1592V13.5387H22.2221V25.4397H19.1615V10.8816H30.7883C32.9243 10.8816 34.2174 12.2048 34.2174 14.3097H34.2183ZM16.8389 10.8816V26.0308C16.8389 27.8128 16.0436 31.1194 10.8422 31.1194H9.55403V28.4322H10.8422C12.8878 28.3942 13.7365 27.5319 13.7715 26.0502V25.4397H11.2107C9.17583 25.4397 7.78167 24.0679 7.78167 22.0116V14.3097C7.78167 12.2612 9.14472 10.8816 11.2107 10.8816H16.8389ZM13.7783 13.5377H12.0546C11.3313 13.5377 10.8413 14.0442 10.8413 14.7462V21.5401C10.8413 22.2741 11.3575 22.7787 12.0886 22.7787H13.7764V13.5367L13.7783 13.5377ZM19.1625 31.1203H34.2183V28.4322H19.1625V31.1203Z"
        fill="white" />
    </svg>
  </div>
  @if(isAuthenticated){
  <div class="flex-column col-12 col-md-auto order-3 order-md-2 ">
    <span class="d-flex gap-24-32md">

      @for(item of menuItems; track item){
      <div class="stat-button-link nav-button nav-item text-white gb-body1 py-1 pointer" data-dtm="global nav"
        routerLink="/{{item.route | lowercase}}" routerLinkActive="active-navbar-item">
        {{item.name}}
      </div>}
    </span>
  </div>
  <div class="flex-column order-2 order-md-3 justify-content-end">
    <div class="d-flex gap-2 align-items-center pointer" (click)="signOut(null)">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="17.1" stroke="white" stroke-width="1.8" />
        <path d="M8.09998 28.8C8.09998 28.8 11.9111 23.4 18.0542 23.4C24.1972 23.4 27.9 28.8 27.9 28.8" stroke="white"
          stroke-width="1.8" />
        <circle cx="18" cy="17.1" r="5.4" stroke="white" stroke-width="1.8" />
      </svg>
      <span class="d-flex signInOut">Sign Out</span>
    </div>
  </div>
  }@else{
  <div class="flex-column d-none d-md-flex col-12 col-md-auto order-3 order-md-2 ">
  </div>
  <div class="flex-column order-2 order-md-3 justify-content-end">
    <div class="d-flex gap-2 align-items-center pointer stat-button-link" data-dtm="sign in" (click)="login()">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="17.1" stroke="white" stroke-width="1.8" />
        <path d="M8.09998 28.8C8.09998 28.8 11.9111 23.4 18.0542 23.4C24.1972 23.4 27.9 28.8 27.9 28.8" stroke="white"
          stroke-width="1.8" />
        <circle cx="18" cy="17.1" r="5.4" stroke="white" stroke-width="1.8" />
      </svg>
      <span class=" d-flex signInOut">Sign In</span>
    </div>
  </div>
  }
</nav>
</div>
